import { BlogPost } from "@/types/blog-post";

import body from "./body.mdx";

const introducingMml: BlogPost = {
  title: "Introducing MML",
  description:
    "MML: An Open Source Metaverse Markup Language for Multi-User Interactive 3D Experiences",
  date: "2023-06-15",
  body,
  image: "/images/blog/introducing-mml.jpeg",
};

export default introducingMml;
